<template>
  <div v-if="$store && $store.state">
    <q-layout view="hHr lpr fFr">
      <q-header
          v-if="$store.state.isLogged===true" class="bg-indigo">
        <q-toolbar>
          <q-btn
              flat
              dense
              round
              @click="leftDrawerOpen = !leftDrawerOpen"
              aria-label="Menu"
              class="q-mr-xs"
              icon="menu"
          />

          <q-toolbar-title class="no-padding">
            <div>
              <span>{{ $store.state.appTitle }}</span>
              <q-badge color="red" align="top" class="q-ml-sm" :label="$store.state.appVersion"/>
            </div>
          </q-toolbar-title>

          <div v-if="$store.state.isLogged===true && $store.state.roles">
            <q-btn class="q-mr-xs" round color="purple" text-color="white"
                   v-if="!$store.state.roles.some(v=>['user_visitor', 'user_store','user_purchase','user_driver'].includes(v))"
                   :icon="notifyList.length>0?'notifications_active':'notifications'">
              <q-badge v-if="notifyList.length>0 || checkList.length>0" floating color="red"
                       text-color="white"
                       :label="notifyList.length + checkList.length"/>
              <q-popup-proxy v-if="notifyList.length>0 || checkList.length>0">
                <q-card flat>
                  <q-card-section class="no-padding">
                    <q-list separator v-if="notifyList.length>0">
                      <q-item>
                        <q-item-section>
                          سر رسید پرداخت فاکتور
                        </q-item-section>
                      </q-item>
                      <q-item v-for="(item, index) in notifyList" :key="index">
                        <q-item-section side>
                          <q-chip size="sm" square
                                  :label="item.Cs_Name"/>
                        </q-item-section>
                        <q-item-section side>
                          <q-chip color="purple" text-color="white" size="sm" square
                                  :label="item.Sale_Date">
                            <q-tooltip>
                              تاریخ فاکتور
                            </q-tooltip>
                          </q-chip>
                        </q-item-section>
                        <q-item-section side>
                          <q-chip color="green" text-color="white" size="sm" square
                                  :label="item.Cs_Pay | toLoalString" icon="attach_money">
                            <q-tooltip>
                              مبلغ فاکتور
                            </q-tooltip>
                          </q-chip>
                        </q-item-section>
                        <q-item-section side v-if="item.RemCredit">
                          <q-chip :color="item.RemCredit>0?'red':'green'" text-color="white"
                                  size="sm" square
                                  :label="item.RemCredit | toLoalString" icon="attach_money">
                            <q-tooltip>
                              بدهکاری/بستانکاری
                            </q-tooltip>
                          </q-chip>
                        </q-item-section>
                      </q-item>
                    </q-list>
                  </q-card-section>
                  <q-card-section class="no-padding" v-if="checkList.length>0">
                    <q-list separator>
                      <q-item>
                        <q-item-section>
                          سر رسید پرداخت چک
                        </q-item-section>
                      </q-item>
                      <q-item v-for="(item, index) in checkList" :key="index">
                        <q-item-section>
                          <q-chip size="sm" square
                                  :label="item.Name"/>
                        </q-item-section>
                        <q-item-section side>
                          <q-chip color="purple" text-color="white" size="sm" square
                                  :label="changeDateFormat(item.ExpiryDate)">
                            <q-tooltip>
                              تاریخ سررسید
                            </q-tooltip>
                          </q-chip>
                        </q-item-section>
                        <q-item-section side>
                          <q-chip color="green" text-color="white" size="sm" square
                                  :label="item.Fee | toLoalString" icon="attach_money">
                            <q-tooltip>
                              مبلغ چک
                            </q-tooltip>
                          </q-chip>
                        </q-item-section>
                        <q-item-section side v-if="item.RemCredit">
                          <q-chip :color="item.RemCredit>0?'red':'green'" text-color="white"
                                  size="sm" square
                                  :label="item.RemCredit | toLoalString" icon="attach_money">
                            <q-tooltip>
                              بدهکاری/بستانکاری
                            </q-tooltip>
                          </q-chip>
                        </q-item-section>
                      </q-item>
                    </q-list>
                  </q-card-section>

                </q-card>
              </q-popup-proxy>
            </q-btn>
            <q-fab
                icon="shortcut"
                direction="down"
                color="purple"
                padding="sm"
                class="q-mr-xs z-fab"
                v-if="$store.state.roles"
            >
              <q-fab-action color="purple" icon="person_add" external-label label="ثبت مشتری جدید"
                            label-position="left"
                            v-if="$store.state.roles.some(v=>['admin','can_insert_new_customer','user_sell','user_visitor'].includes(v))"
                            @click="buyList=false;showInsertCustomerDialog=true;"/>
              <q-fab-action color="purple" icon="person_add" external-label label="ثبت تامین کننده جدید"
                            label-position="left"
                            v-if="$store.state.roles.some(v=>['admin','user_purchase'].includes(v))"
                            @click="buyList=true;showInsertCustomerDialog=true"/>
              <q-fab-action color="purple" icon="add_comment" external-label label="ثبت گزارش"
                            label-position="left"
                            @click="addComment"/>
              <q-fab-action color="purple" icon="email" external-label label="ارسال پیامک"
                            label-position="left"
                            @click="sendSMS"
                            v-if="$store.state.roles.some(v=>['admin','can_send_sms'].includes(v))"/>
              <q-fab-action color="purple" icon="add_shopping_cart" external-label label="ثبت سفارش"
                            v-if="$store.state.roles.some(v=>['admin','can_issue_order'].includes(v))"
                            label-position="left" to="/orders-list"/>
              <q-fab-action color="purple" icon="local_phone"
                            external-label label="برقراری تماس آزاد"
                            label-position="left"
                            @click="directCall"
                            v-if="$store.state.roles.some(v=>['admin','free_call'].includes(v))"/>
              <q-fab-action color="purple" icon="phone_in_talk"
                            external-label label="برقراری تماس داخلی" label-position="left"
                            @click="showInternalCallDialog"
                            v-if="$store.state.roles.some(v=>['admin','can_internal_call'].includes(v))"/>
            </q-fab>
            <q-btn round padding="sm" color="purple" icon="exit_to_app" @click="logout"/>
          </div>
        </q-toolbar>
      </q-header>

      <q-drawer
          v-model="leftDrawerOpen"
          show-if-above
          bordered
          overlay
          behavior="mobile"
          content-class="bg-grey-2"
          v-if="$store.state.isLogged===true"
      >
        <q-list v-if="$store.state.roles">
          <q-item-label class="q-ma-sm">
            <q-banner rounded inline-actions class="bg-blue text-white">
              <template v-slot:avatar>
                <q-avatar size="md" class="q-mr-sm" color="purple" text-color="white">
                  {{ $store.state.firstName.charAt(0) }} {{ $store.state.lastName.charAt(0) }}
                </q-avatar>
                {{ $store.state.firstName }} {{ $store.state.lastName }}
              </template>
            </q-banner>
          </q-item-label>
          <q-separator/>
          <q-item class="no-padding"
                  v-if="$store.state.roles.some(v=>['admin','can_see_dashboard','can_sea_order_trace','user_visitor'].includes(v))">
            <q-item-section>
              <q-expansion-item
                  expand-separator
                  icon="analytics"
                  label="داشبورد"
                  dense
              >
                <q-item dense class="q-ml-md" clickable
                        v-if="$store.state.roles.some(v=>['admin','can_see_sell_buy_order_trace'].includes(v))"
                        to="/sell_buy_order_trace">
                  <q-item-section avatar>
                    <q-icon name="analytics"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>رهگیری سفارشات خرید و فروش</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item dense class="q-ml-md" clickable
                        v-if="$store.state.roles.some(v=>['admin','can_see_operation_function'].includes(v))"
                        to="/dashboard">
                  <q-item-section avatar>
                    <q-icon name="analytics"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>عملکرد فروش</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item dense class="q-ml-md" clickable
                        v-if="$store.state.roles.some(v=>['admin','can_see_operation_function'].includes(v))"
                        to="/dashboard-duration">
                  <q-item-section avatar>
                    <q-icon name="analytics"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>عملکرد فروش در باز زمانی خاص</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item dense class="q-ml-md" clickable
                        v-if="$store.state.roles.some(v=>['admin','can_see_30days_report'].includes(v))"
                        to="/sale_dashboard">
                  <q-item-section avatar>
                    <q-icon name="analytics"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>وضعیت سی روزه فروش</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item dense class="q-ml-md" clickable
                        v-if="$store.state.roles.some(v=>['admin','can_see_yearly_report'].includes(v))"
                        to="/sale_yearly_dashboard">
                  <q-item-section avatar>
                    <q-icon name="analytics"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>وضعیت سالیانه فروش</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item dense class="q-ml-md" clickable
                        v-if="$store.state.roles.some(v=>['admin','user_purchase'].includes(v))"
                        to="/buy_yearly_dashboard">
                  <q-item-section avatar>
                    <q-icon name="analytics"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>وضعیت سالیانه خرید</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item dense class="q-ml-md" clickable
                        v-if="$store.state.roles.some(v=>['admin','can_see_frm'].includes(v))"
                        to="/customer_frm">
                  <q-item-section avatar>
                    <q-icon name="analytics"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>ارزشیابی طرف معامله</q-item-label>
                  </q-item-section>
                </q-item>
              </q-expansion-item>
            </q-item-section>
          </q-item>
          <q-item class="no-padding"
                  v-if="$store.state.roles.some(v=>['admin','user_finance'].includes(v))">
            <q-item-section>
              <q-expansion-item
                  expand-separator
                  icon="local_mall"
                  label="مالی"
                  dense
              >
                <q-item clickable v-if="$store.state.roles.some(v=>['admin','can_see_main_account_transactions'].includes(v))"
                        to="/get-transaction">
                  <q-item-section avatar>
                    <q-icon name="receipt_long"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>مدیریت حساب های بانکی</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','user_finance'].includes(v))"
                        to="/customers-search/2">
                  <q-item-section avatar>
                    <q-icon name="people"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>تامین کنندگان</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable
                        to="/total_buy_factors">
                  <q-item-section avatar>
                    <q-icon name="receipt_long"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>لیست فاکتورهای خرید</q-item-label>
                  </q-item-section>
                </q-item>

              </q-expansion-item>
            </q-item-section>
          </q-item>
          <q-item class="no-padding"
                  v-if="$store.state.roles.some(v=>['admin','user_purchase'].includes(v))">
            <q-item-section>
              <q-expansion-item
                  expand-separator
                  icon="local_mall"
                  label="خرید"
                  dense
              >
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_see_buy_order_trace'].includes(v))"
                        to="/buy_order_trace">
                  <q-item-section avatar>
                    <q-icon name="local_mall"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>رهگیری سفارشات خرید</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','user_purchase'].includes(v))"
                        to="/customers-search/2">
                  <q-item-section avatar>
                    <q-icon name="people"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>تامین کنندگان</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_entry_buy_goods_order'].includes(v))"
                        to="/products-search">
                  <q-item-section avatar>
                    <q-icon name="inventory_2"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>محصولات</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_see_inventory_list', 'can_only_numerical_exists_store'].includes(v)) && !$q.screen.lt.md"
                        to="/inventory_list">
                  <q-item-section avatar>
                    <q-icon name="inventory_2"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>لیست موجودی</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        to="/buy_order">
                  <q-item-section avatar>
                    <q-icon name="shopping_cart"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>ثبت سفارش خرید</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        to="/total_buy_factors">
                  <q-item-section avatar>
                    <q-icon name="receipt_long"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>لیست فاکتورهای خرید</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_manage_goods_group'].includes(v))"
                        to="/goods-groups">
                  <q-item-section avatar>
                    <q-icon name="inventory_2"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>گروه کالاها</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_change_goods_price'].includes(v))"
                        to="/goods-price">
                  <q-item-section avatar>
                    <q-icon name="local_mall"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>قیمت گذاری</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_show_storage_boiling_point_page'].includes(v))"
                        to="/get-storage_boiling_point">
                  <q-item-section avatar>
                    <q-icon name="store"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>نقطه جوش محصولات</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_see_remain_order'].includes(v))"
                        to="/remain-orders">
                  <q-item-section avatar>
                    <q-icon name="list_alt"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>گزارش مانده سفارش</q-item-label>
                  </q-item-section>
                </q-item>
              </q-expansion-item>
            </q-item-section>
          </q-item>

          <q-item class="no-padding"
                  v-if="$store.state.roles.some(v=>['admin','user_sell','user_visitor', 'salemanager'].includes(v))">
            <q-item-section>
              <q-expansion-item
                  expand-separator
                  icon="shopping_basket"
                  label="فروش"
                  dense
              >
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_send_buy_request'].includes(v))"
                        to="/buy_request">
                  <q-item-section avatar>
                    <q-icon name="table_chart"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>درخواست خرید</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_sea_order_trace','can_issue_way_bill'].includes(v))"
                        to="/order-trace">
                  <q-item-section avatar>
                    <q-icon name="table_chart"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>رهگیری سفارشات فروش</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['user_visitor','user_sell'].includes(v))"
                        to="/my_order_list">
                  <q-item-section avatar>
                    <q-icon name="table_chart"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>سفارشات من</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_manage_goods_group'].includes(v))"
                        to="/goods-groups">
                  <q-item-section avatar>
                    <q-icon name="inventory_2"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>گروه کالاها</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_manage_goods_group'].includes(v))"
                        to="/goods-groups-tree">
                  <q-item-section avatar>
                    <q-icon name="inventory_2"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>ساختاربندی گروه کالاها</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_see_products_list'].includes(v))"
                        to="/products-search">
                  <q-item-section avatar>
                    <q-icon name="inventory_2"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>محصولات</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_see_inventory_list', 'can_only_numerical_exists_store'].includes(v)) && !$q.screen.lt.md"
                        to="/inventory_list">
                  <q-item-section avatar>
                    <q-icon name="inventory_2"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>لیست موجودی</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_see_customer_list'].includes(v))"
                        to="/customers-search/1">
                  <q-item-section avatar>
                    <q-icon name="people"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>مشتریان</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_issue_order'].includes(v))"
                        to="/orders-list">
                  <q-item-section avatar>
                    <q-icon name="list_alt"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>ثبت سفارش</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_see_all_factors'].includes(v))"
                        to="/factors">
                  <q-item-section avatar>
                    <q-icon name="list_alt"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>فاکتورها</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_see_customer_Demands'].includes(v))"
                        to="/list-of-financial-claims">
                  <q-item-section avatar>
                    <q-icon name="attach_money"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>مطالبات</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_see_remain_order'].includes(v))"
                        to="/remain-orders">
                  <q-item-section avatar>
                    <q-icon name="list_alt"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>گزارش مانده سفارش</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item class="no-padding"
                        v-if="$store.state.roles.some(v=>['admin','can_manage_sale_target'].includes(v))">
                  <q-item-section>
                    <q-expansion-item
                        expand-separator
                        icon="track_changes"
                        label="اهداف فروش"
                        dense
                    >
                    </q-expansion-item>

                  </q-item-section>
                </q-item>
                <q-item dense clickable class="q-ml-md"
                        v-if="$store.state.roles.some(v=>['admin','can_manage_sale_target'].includes(v))"
                        to="/sale_targets/last">
                  <q-item-section avatar>
                    <q-icon name="track_changes"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>هدف‌گذاری فروش</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item dense clickable class="q-ml-md"
                        v-if="$store.state.roles.some(v=>['admin','can_manage_sale_target'].includes(v))"
                        to="/sale_targets/all">
                  <q-item-section avatar>
                    <q-icon name="track_changes"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>آرشیو اهداف فروش</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item
                    v-if="$store.state.roles.some(v=>['admin','can_manage_questionanire'].includes(v))"
                    clickable
                    to="/questionnaire">
                  <q-item-section avatar>
                    <q-icon name="quiz"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>پرسشنامه طرف معامله</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_sea_employee_locations'].includes(v))"
                        to="/locations">
                  <q-item-section avatar>
                    <q-icon name="location_on"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>موقعیت مکانی پرسنل و طرف معامله</q-item-label>
                  </q-item-section>
                </q-item>

              </q-expansion-item>
            </q-item-section>
          </q-item>
          <q-item class="no-padding"
                  v-if="$store.state.roles.some(v=>['admin','management'].includes(v)) && !$q.screen.lt.md">
            <q-item-section>
              <q-expansion-item
                  expand-separator
                  icon="shopping_basket"
                  label="مدیریت"
                  dense
              >
                <q-item clickable
                        to="/goods-groups">
                  <q-item-section avatar>
                    <q-icon name="inventory_2"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>گروه کالاها</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        to="/products-search">
                  <q-item-section avatar>
                    <q-icon name="inventory_2"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>محصولات</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        to="/customers-search/0">
                  <q-item-section avatar>
                    <q-icon name="people"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>مشتریان و تامین کنندگان</q-item-label>
                  </q-item-section>
                </q-item>
              </q-expansion-item>
            </q-item-section>
          </q-item>
          <q-item class="no-padding"
                  v-if="$store.state.roles.some(v=>['admin','user_store'].includes(v))">
            <q-item-section>
              <q-expansion-item
                  expand-separator
                  icon="store"
                  label="انبار"
                  dense
              >
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['user_store'].includes(v))"
                        to="/my_order_list">
                  <q-item-section avatar>
                    <q-icon name="table_chart"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>سفارشات من</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable v-if="$store.state.roles.some(v=>['admin','user_store'].includes(v))"
                        to="/my">
                  <q-item-section avatar>
                    <q-icon name="email"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>درخواست های انبار</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable v-if="$store.state.roles.some(v=>['admin','user_store'].includes(v))"
                        to="/products-search">
                  <q-item-section avatar>
                    <q-icon name="inventory_2"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>محصولات</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_see_inventory_list', 'can_only_numerical_exists_store'].includes(v)) && !$q.screen.lt.md"
                        to="/inventory_list">
                  <q-item-section avatar>
                    <q-icon name="inventory_2"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>لیست موجودی</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_goods_transfer'].includes(v))"
                        to="/goods_transfer">
                  <q-item-section avatar>
                    <q-icon name="transfer_within_a_station"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>انتقال بین انبارها</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_see_exit_product_document'].includes(v))"
                        to="/exit-documents">
                  <q-item-section avatar>
                    <q-icon name="list_alt"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>حواله ها</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_see_all_way_bill'].includes(v))"
                        to="/all-way-bill">
                  <q-item-section avatar>
                    <q-icon name="local_shipping"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>بارنامه ها</q-item-label>
                  </q-item-section>
                </q-item>
              </q-expansion-item>
            </q-item-section>
          </q-item>
          <q-item class="no-padding"
                  v-if="$store.state.roles.some(v=>['admin','can_manage_shop'].includes(v))">
            <q-item-section>
              <q-expansion-item
                  expand-separator
                  icon="store"
                  label="فروشگاه"
                  dense
              >
                <q-item clickable v-if="$store.state.roles.some(v=>['admin','can_manage_shop'].includes(v))"
                        to="/shop-request">
                  <q-item-section avatar>
                    <q-icon name="email"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>درخواست های انبار</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable v-if="$store.state.roles.some(v=>['admin','can_entry_shop_order'].includes(v))"
                        to="/shop-order">
                  <q-item-section avatar>
                    <q-icon name="shop"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>ثبت سفارش خرده فروشی</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_goods_transfer'].includes(v))"
                        to="/goods_transfer">
                  <q-item-section avatar>
                    <q-icon name="transfer_within_a_station"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>انتقال بین انبارها</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_manage_shop'].includes(v))"
                        to="/shop_boiling_point">
                  <q-item-section avatar>
                    <q-icon name="transfer_within_a_station"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>مشاهده نقطه جوش کالاهای فروشگاه</q-item-label>
                  </q-item-section>
                </q-item>
              </q-expansion-item>

            </q-item-section>
          </q-item>
          <q-item class="no-padding"
                  v-if="$store.state.roles.some(v=>['admin','user_driver'].includes(v))">
            <q-item-section>
              <q-expansion-item
                  expand-separator
                  icon="local_shipping"
                  label="حمل و نقل"
                  dense
              >
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_manage_drivers'].includes(v)) && !$q.screen.lt.md"
                        to="/list-of-drivers">
                  <q-item-section avatar>
                    <q-icon name="local_shipping"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>بانک اطلاعاتی رانندگان</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable v-if="$store.state.roles.some(v=>['admin','user_driver'].includes(v))"
                        to="/driver_remittance_list">
                  <q-item-section avatar>
                    <q-icon name="store"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>لیست حواله های من</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_see_drivers_balance-info'].includes(v)) ||
                              $store.state.roles.some(v=>['user_driver'].includes(v))"
                        to="/get-drivers-balance-info">
                  <q-item-section avatar>
                    <q-icon name="attach_money"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>بررسی وضعیت پرداخت بارنامه</q-item-label>
                  </q-item-section>
                </q-item>
              </q-expansion-item>
            </q-item-section>
          </q-item>

          <q-item class="no-padding"
                  v-if="$store.state.roles.some(v=>['admin','free_call'].includes(v))">
            <q-item-section>
              <q-expansion-item
                  expand-separator
                  icon="settings"
                  label="ابزارها"
                  dense
              >
                <q-item clickable v-if="$store.state.roles.some(v=>['admin','free_call'].includes(v))"
                        to="/call_center">
                  <q-item-section avatar>
                    <q-icon name="phone"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>مرکز تماس و پیامک</q-item-label>
                  </q-item-section>
                </q-item>
              </q-expansion-item>
            </q-item-section>
          </q-item>
          <q-item class="no-padding"
                  v-if="$store.state.roles.some(v=>['admin','can_see_report_menu'].includes(v))">
            <q-item-section>
              <q-expansion-item
                  expand-separator
                  icon="book"
                  label="گزارشات"
                  dense
              >
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_see_report_menu'].includes(v))"
                        to="/reports">
                  <q-item-section avatar>
                    <q-icon name="book"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>گزارش تامین کنندگان کالا</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_see_report_menu'].includes(v))"
                        to="/reports-stor-minus">
                  <q-item-section avatar>
                    <q-icon name="book"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>گزارش موجودی منفی کالاهای یک انبار</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable
                        v-if="$store.state.roles.some(v=>['admin','can_see_report_menu'].includes(v))"
                        to="/reports-warehouse-handling">
                  <q-item-section avatar>
                    <q-icon name="book"/>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>چاپ فرم انبارگردانی</q-item-label>
                  </q-item-section>
                </q-item>
              </q-expansion-item>
            </q-item-section>
          </q-item>
          <q-item clickable
                  to="/settings">
            <q-item-section avatar>
              <q-icon name="settings"/>
            </q-item-section>
            <q-item-section>
              <q-item-label>تنظیمات</q-item-label>
            </q-item-section>
          </q-item>

          <q-item clickable v-if="$store.state.roles.some(v=>['admin','can_see_pay_document'].includes(v))"
                  to="/pay-documents">
            <q-item-section avatar>
              <q-icon name="attach_money"/>
            </q-item-section>
            <q-item-section>
              <q-item-label>اسناد پرداختی</q-item-label>
            </q-item-section>
          </q-item>

          <q-item clickable v-if="$store.state.roles.some(v=>['admin','can_manage_users'].includes(v))"
                  to="/users">
            <q-item-section avatar>
              <q-icon name="group"/>
            </q-item-section>
            <q-item-section>
              <q-item-label>مدیریت کاربران</q-item-label>
            </q-item-section>
          </q-item>
        </q-list>
      </q-drawer>
      <q-page-container>
        <q-page>
          <transition name="fade" mode="out-in">
            <router-view :key="$route.fullPath"/>
          </transition>
        </q-page>
      </q-page-container>
    </q-layout>
    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showInsertCustomerDialog">
      <CUCustomerInfo :buy-list="buyList" action="insert" @customer-updated="customerUpdated"/>    </q-dialog>
    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showEventDialog">
      <q-card>
        <q-card-section>
          <CUVisitLog @event-added="closeEventDialog" :selected-customer="this.selectedCustomer"/>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="showSMSPanel">
      <SMSPanel :customer="selectedCustomer" @sms_sended="sms_sended"/>
    </q-dialog>
    <q-dialog v-model="showCallPanelDialog"
              :full-width="$q.screen.lt.md">
      <CallPanel :is-dialog="true" :call-number.sync="callNumber" :custom-call="true" :showHeader="true"/>
    </q-dialog>
    <q-dialog v-model="internalCallDialog">
      <InternalCall :is-dialog="true"/>
    </q-dialog>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import axios from "axios";
import store from "./store";
import {registerPlugin} from "@capacitor/core";
import {Device} from "@capacitor/device";
import CUCustomerInfo from "./components/customers/CUCustomerInfo";
import EventBus from "./event-bus";
import CUVisitLog from "./components/customers/CUVisitLog";
import SMSPanel from "@/components/callCenter/SMSPanel";
import CallPanel from "@/components/callCenter/CallPanel";
import InternalCall from "@/components/callCenter/InternalCall";
import {Client} from "@stomp/stompjs";

const BackgroundGeolocation = registerPlugin("BackgroundGeolocation");

export default {
  name: 'LayoutDefault',
  components: {InternalCall, CallPanel, SMSPanel, CUVisitLog, CUCustomerInfo},
  data() {
    return {
      watcherId: undefined,
      buyList: false,
      leftDrawerOpen: false,
      draggingFab: false,
      showSplash: true,
      today: '',
      loc: '',
      showInsertCustomerDialog: false,
      selectedCustomer: '',
      showEventDialog: false,
      showSMSPanel: false,
      callNumber: '',
      showCallPanelDialog: false,
      notifyList: [],
      checkList: [],
      internalCallDialog: false,
    }
  },
  methods: {
    ...mapActions({
      logOut: "Authenticate/logout",
      AddLocation: 'Authenticate/addLocation',
      sendMessage: 'sendMessage',
      setNotify: 'Dashboard/getNotify',
      setPayVisited: 'Dashboard/set_customer_pay_visited',
      getRoles: 'getRoles'
    }),
    notifyActionButton(item) {
      if (item.TyTitle === 0) {
        this.setPayVisited(item.ID).then((res) => {
          if (res.result === 1) {
            this.notifyList = this.notifyList.filter(record => record.ID !== item.ID)
          }
        })
      }
    },
    showInternalCallDialog() {
      this.internalCallDialog = true
    },
    dial(number) {
      this.callNumber = number;
      this.showCallPanelDialog = true;
    },
    customerUpdated() {
      this.showInsertCustomerDialog = false;
    },
    logout() {
      this.logOut();
      this.$router.push("/login")
    },
    async getCurrentPosition() {
      const client = new Client({
        brokerURL: 'wss://rabbit.norl.ir:15673/ws',
        connectHeaders: {
          login: 'user_tracking',
          passcode: 'FP2QrRhz!6i92rz',
        },
        reconnectDelay: 5000,
        heartbeatIncoming: 4000,
        heartbeatOutgoing: 4000,

      });
      client.onConnect = async function (frame) {
        if (frame.command === 'CONNECTED') {
          if ((await Device.getInfo()).platform !== "web") {
            let last_location;
            await BackgroundGeolocation.addWatcher(
                {
                  requestPermissions: true,
                  stale: false,
                },
                async function (location) {
                  last_location = location || undefined;
                  const locationData = {
                    latitude: last_location.latitude,
                    longitude: last_location.longitude,
                    accuracy: last_location.accuracy,
                    speed: last_location.speed,
                    userName: window.localStorage.getItem("userName"),
                    uuid: await Device.getId(),
                  }
                  client.publish({
                    destination: '/exchange/user_tracking',
                    body: JSON.stringify(locationData)
                  });
                }
            ).then(function (id) {
              this.$store.state.watcherId = id
            });
          }
        }
      };
      client.onStompError = async function (err) {
        console.log(err)
      };
      client.activate();
      this.$store.state.rabbitmqClient = client
    },
    addComment() {
      this.$q.dialog({
        title: 'ثبت گزارش کار/توضیحات طرف معامله',
        ok: {
          label: 'گزارش کار'
        },
        cancel: {
          label: 'توضیحات طرف معامله',
          color: 'red',
          flat: true
        },
        persistent: true,
      }).onOk(() => {
        this.showEventDialog = true
      }).onCancel(() => {
        if (this.selectedCustomer === '') {
          this.$router.push("/customers-search/1").catch(() => {
          })
        } else {
          this.showEventDialog = true
        }
      }).onDismiss(() => {
        // console.log('I am triggered on both OK and Cancel')
      })
    },
    sendSMS() {
      if (this.selectedCustomer === '') {
        this.$router.push("/customers-search/1").catch(() => {
        })
      } else {
        this.showSMSPanel = true
      }
    },
    sms_sended() {
      this.showSMSPanel = false
    },
    closeEventDialog() {
      this.showEventDialog = false
    },
    directCall() {
      this.showCallPanelDialog = true
    },
    sendMessageForDirectCall(number) {
      this.sendMessage(`${this.$store.state.avayaExt}&${number}`).then((res) => {
        if (res.msg === 'success') {
          this.$q.notify({
            type: 'positive',
            position: 'top',
            color: 'positive',
            message: 'تا لحظاتی دیگر تماس شما برقرار خود شد، لطفا اندکی تامل فرمایید'
          });
        } else {
          this.$q.notify({
            type: 'negative',
            position: 'top',
            color: 'negative',
            message: 'ارتباط با مرکر تماس قطع است'
          });
          this.onReset();
        }
      }).catch(() => {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          color: 'negative',
          message: 'ارتباط با مرکر تماس قطع است'
        });
        this.onReset()
      });
    },
    loadNotify() {
      this.setNotify().then((res) => {
        this.notifyList = JSON.parse(res.pay)
        this.notifyList = this.notifyList.filter(item => item.TyTitle === 1)
        this.$store.state.checkList = this.lodash.orderBy(JSON.parse(res.checkList), ['ExpiryDate'], ['desc'])
        this.checkList = this.$store.state.checkList.filter(
            item => item.ExpiryDate >= parseInt(this.getTodayDateJalaliInt())
                && item.ExpiryDate <= parseInt(this.getTodayDateJalaliInt()) + 1)
      })
    }
  },
  computed: {
    logo() {
      return this.getStaticImage('logo.png')
    }
  },
  async created() {
    const info = await Device.getInfo();
    this.$store.state.uuid = info.uuid
    let token = window.localStorage.getItem("access_token");
    if (token !== null) {
      this.$store.state.accessToken = window.localStorage.getItem("access_token");
      this.$store.state.userName = window.localStorage.getItem("userName");
      this.$store.state.roles = JSON.parse(window.localStorage.getItem("roles"));
      this.$store.state.firstName = window.localStorage.getItem("firstName");
      this.$store.state.lastName = window.localStorage.getItem("lastName");
      this.$store.state.userMobile = window.localStorage.getItem("userMobile");
      this.$store.state.internalUserMobile = window.localStorage.getItem("internalUserMobile");
      this.$store.state.internalUserMobile2 = window.localStorage.getItem("internalUserMobile2");
      this.$store.state.postfixPhone1 = window.localStorage.getItem("postfixPhone1");
      this.$store.state.postfixPhone2 = window.localStorage.getItem("postfixPhone2");
      this.$store.state.postfixPhone3 = window.localStorage.getItem("postfixPhone3");
      this.$store.state.avayaExt = window.localStorage.getItem("avayaExt");
      this.$store.state.storeAccessList = window.localStorage.getItem("storeAccessList");
      this.$store.state.issueOrderRemittanceStoreList = window.localStorage.getItem("issueOrderRemittanceStoreList");
      this.$store.state.phone = window.localStorage.getItem("phone");
      this.$store.state.userId = window.localStorage.getItem("userID");
      axios.defaults.headers.Authorization = store.state.jwtType + store.state.accessToken;
      this.$store.state.isLogged = true;
      this.getRoles().then((res) => {
        this.$store.state.roles = res
      })
      await this.getCurrentPosition()

      setInterval(() => {
        this.loadNotify()
      }, 3600000)
      this.loadNotify()
      if (window.location.href.includes('customer-dashboard')) {
        if (this.$route.query.customerId === undefined) {
          this.$router.push("/customer-dashboard/-1").catch(() => {
          })
        } else {
          this.$router.push("/customer-dashboard/" + this.$route.query.customerId).catch(() => {
          })
        }
      } else {
        if (this.$store.state.roles.some(v => ['admin'].includes(v))) {
          this.$router.push("/sell_buy_order_trace").catch(() => {
          })
        } else if (this.$store.state.roles.some(v => ['user_purchase'].includes(v)) && this.$store.state.roles.some(v => ['user_sell'].includes(v))) {
          this.$router.push("/sell_buy_order_trace").catch(() => {
          })
        }else if (this.$store.state.roles.some(v => ['user_purchase'].includes(v))) {
          this.$router.push("/buy_order_trace").catch(() => {
          })
        } else if (this.$store.state.roles.some(v => ['user_sell'].includes(v))) {
          this.$router.push("/order-trace").catch(() => {
          })
        } else if (this.$store.state.roles.some(v => ['user_store'].includes(v))) {
          this.$router.push("/my").catch(() => {
          })
        } else if (this.$store.state.roles.some(v => ['user_visitor'].includes(v)) || !this.$store.state.roles.some(v => ['can_see_all_trace_orders'].includes(v))) {
          this.$router.push("/my_order_list").catch(() => {
          })
        } else {
          this.$router.push("/order-trace").catch(() => {
          })
        }
      }
    } else {
      this.$store.state.isLogged = false;
    }
  },
  mounted() {
    EventBus.$on('invoke-selected-customer', payload => {
      this.selectedCustomer = payload;
    });
  },
  async beforeDestroy() {
    this.$store.state.rabbitmqClient.forceDisconnect()
    if ((await Device.getInfo()).platform !== "web") {
      await BackgroundGeolocation.removeWatcher({
        id: this.$store.state.watcherId
      });
    }
  },
  meta() {
    return {
      title: this.$store.state.appTitle
    }
  }
}
</script>

<style>
@import "styles/fontiran.css";

* {
  font-family: "IRANSans", sans-serif;
}

.my-class > td:before {
  background: rgba(0, 0, 0, 0) !important;
  border: none;
}

input[type="time"]::-webkit-calendar-picker-indicator {
  background: none;
  display: none;
}
</style>
